module.exports = __webpack_public_path__ + "img/exclamacion.40384741.svg";